import Tooltip from '@mui/material/Tooltip';

import {
	formatTooltipDate,
	TIMESTAMP_TOOLTIP_ENTER_DELAY_MS,
	TIMESTAMP_TOOLTIP_ENTER_NEXT_DELAY_MS,
	useRelativeLabel,
} from './format-relative-date.js';

export interface RelativeDateProps {
	date: Date | null | undefined;
	/** Fallback string when `date` is missing. Defaults to an em-dash. */
	fallback?: string;
	className?: string;
	/** When true, render compact unit-by-unit form ("5m 30s ago") instead of the loose phrase ("5 minutes ago"). */
	precise?: boolean;
}

/**
 * Renders a date as a relative timestamp ("about 2 hours ago", "in 3 days")
 * with a hover tooltip showing the precise calendar value. Re-formats every
 * second so the relative label stays current.
 */
export function RelativeDate({ date, fallback = '—', className, precise = false }: RelativeDateProps) {
	const label = useRelativeLabel(date, precise);

	if (date === null || date === undefined) {
		return <span className={className}>{fallback}</span>;
	}

	return (
		<Tooltip
			title={formatTooltipDate(date)}
			enterDelay={TIMESTAMP_TOOLTIP_ENTER_DELAY_MS}
			enterNextDelay={TIMESTAMP_TOOLTIP_ENTER_NEXT_DELAY_MS}
		>
			<span className={className}>{label}</span>
		</Tooltip>
	);
}
